import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';

import styles from './_bannerLink.module.less';
import { setIframeVisible } from '../../actions/layout';
import { CONTEXT } from '../../config';
import { logging, logPostInfo } from '../../actions/log';
import { logNative, getUrlByTargetContent } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default ({ cardData, logInfo, children }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  const loggingADXClick = useCallback(bannerADX => {
    // 推荐页面ADX banner点击打桩
    dispatch(
      logging({
        category: 'C',
        action: logInfo.action,
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          advertCrid: bannerADX.advertCrid,
          advertUrl: bannerADX.advertUrl,
        },
        param3: bannerADX.bizInfo,
      }),
    );
    // if (bannerADX && bannerADX.impTracks) {
    //   const clickTracks = JSON.parse(bannerADX.clickTracks);
    //   loggingADX(clickTracks);
    // }
  }, []);

  const handleBanner = useCallback(
    bannerInfo => {
      let targetContent_ = {};
      try {
        targetContent_ = JSON.parse(bannerInfo?.targetContent);
      } catch (error) {}
      // 推荐页面banner点击打桩
      dispatch(
        logging({
          category: 'C',
          action: logInfo.action,
          label: '',
          param2: {
            source: logInfo.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            type: bannerInfo?.targetType,
            id: { ...targetContent_ },
          },
          param3: bannerInfo?.bizInfo,
        }),
      );

      setTimeout(() => {
        if (
          bannerInfo.targetType === '1' ||
          bannerInfo.targetType === '3' ||
          bannerInfo.targetType === '11' ||
          bannerInfo.targetType === '12'
        ) {
          dispatch(
            logPostInfo({
              source: logInfo.source,
              source_pp: logInfoData.source_p,
            }),
          );
          let url = `${CONTEXT}/`;
          if (bannerInfo.targetType && bannerInfo.targetContent) {
            url = getUrlByTargetContent(bannerInfo);
          }
          history.push(url);
        } else if (bannerInfo.targetType === '2') {
          if (bannerInfo.targetUrl) {
            window.open(bannerInfo.targetUrl);
          } else if (bannerInfo.targetContent) {
            try {
              const targetContent = JSON.parse(bannerInfo.targetContent) || {};
              window.open(targetContent.targetUrl);
            } catch (error) {}
          }
        } else if (bannerInfo.targetType === '5' && bannerInfo.targetContent) {
          let targetContent = {};
          try {
            targetContent = JSON.parse(bannerInfo.targetContent);
          } catch (error) {
            logNative(`分析商城URL JSON解析错误:${error}`, error);
          }
          if (targetContent && targetContent.url) {
            dispatch(
              setIframeVisible({
                visible: true,
                url: targetContent.url,
                source: logInfo.source,
              }),
            );
          }
        } else if (
          bannerInfo.targetType === '10' &&
          bannerInfo.advertCrid &&
          bannerInfo.advertUrl
        ) {
          loggingADXClick(bannerInfo);
          window.open(bannerInfo.advertUrl);
        } else {
          history.push(`${CONTEXT}/error`);
        }
      }, 30);
    },
    [dispatch, logInfoData, history],
  );

  return (
    <div
      className={styles.banner_link}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        handleBanner(cardData);
      }}
    >
      {children}
    </div>
  );
};
